import { classes, style } from "typestyle";
import { FunctionComponent } from "react";
import * as React from "react";
import * as csstips from "csstips";

const buttonClassName = style({
  border: "4px solid #FFFFFF",
  borderRadius: "16px",
  boxShadow: "0 1px 2px 0 rgba(0,0,0,0.3)",
  cursor: "pointer",
  height: "48px",
  pointerEvents: "auto",
  width: "48px",
});

interface IButtonProps {
  className?: string;
  onClick: () => void;
  imgSrc: string;
}

const MapViewSwitchButton: FunctionComponent<IButtonProps> = ({
  className,
  onClick,
  imgSrc,
}) => (
  <div onClick={onClick} className={classes(buttonClassName, className)}>
    <img
      src={imgSrc}
      className={style(csstips.fillParent, { borderRadius: "12px" })}
    />
  </div>
);

export default MapViewSwitchButton;
